import { api } from './variables'

export const onlyNumber = (value) => {
    return value.toString().replace(/\D/g,'');
}

export const formatCnpj = (cnpj) => {
    var formatedCnpj = "";

    if(cnpj.length != 14)
    {
        cnpj.split('').forEach((element, index) => {
            formatedCnpj += element;
            if (index === 2)
                formatedCnpj += '.';
            if (index === 5)
                formatedCnpj += '.';
            if (index === 8)
                formatedCnpj += '-';
        })
        return formatedCnpj    
    }

    cnpj.split('').forEach((element, index) => {
        formatedCnpj += element;
        if (index === 1)
            formatedCnpj += '.';
        if (index === 4)
            formatedCnpj += '.';
        if (index === 7)
            formatedCnpj += '/';
        if (index === 11)
            formatedCnpj += '-';
    })

    return formatedCnpj
}

const decode = (param) => {
    var data = param.toString();
    try {
        data = atob(data).toString();
    }
    catch (err) {
        console.log("decode desnecessario")
     }
    
    return data;
}

export const getRequestUrl = (data, cnpj, nota) => {
    if (data) {
        data = decode(data);
        if (data.indexOf("J") >= 0) 
            return api + "/api/gerarTodosBoletos?data=" + data;
        else
            return api + "/api/gerarBoleto?data=" + data; 
    }
    if (nota) {
        return api + `/api/gerarTodosBoletos?nota=${nota}&cnpj=${cnpj}`;
    }
}
